var PortalConfig = {

    // if debug output should be displayed
    debug: null,

    // if cookies created require the secure flag
    secureCookie: false,

    // the url for the host
    hostUrl: '',

    // the url for the portal api
    apiUrl: '',

    // the url to the front end of the portal
    portalUrl: '',

    // the url to the cms resources api
    resourcesUrl: '',

    // the amount of time between refreshing a users login data
    loginDataRefreshTime: 900,

    // the site key of googles invisible recaptcha
    recaptchaSiteKey: '6LcMOjQUAAAAAPTcoL7M7Y8cgxmLA6lFD9c1u8d6',

    // env settings used to determine many of the default configurations
    envSettings: {
        local: {
            hosts: [
                'website.local',
            ],
            debug: true,
            secureCookie: false,
            apiUrl: 'http://customer-portal-api.local',
        },
        dev: {
            hosts: [
	            'website-original-dev.ussignal.com',
	            'dev.ussignal.com',
	            'website-kmotion-dev.ussignal.com',
	            'localhost',
                //'website-ussignal-portal.staging.ussig.net',
                //'website-chat.staging.ussig.net'
            ],
            debug: true,
            secureCookie: false,
            apiUrl: 'https://yellow-sun-6a90.kevin-f0e.workers.dev',
            //apiUrl: 'https://cupo-dev.ussignal.com',
        },
        production: {
            hosts: [
                'ussignal.com',
	            'ussignalbeta.wpenginepowered.com',
            ],
            debug: false,
            secureCookie: true,
            apiUrl: 'https://cupo-api.ussignal.com',
        },
    },

    // sets up configuration options based on hostname
    _setEnv() {
        var hostname = window.location.hostname;
        var protocol = window.location.protocol;
        // try and find our current host in pre-defined settings
        for(var i in this.envSettings) {
            var env = this.envSettings[i];
            if(env.hosts.includes(hostname)) {
                this.debug = env.debug;
                this.secureCookie = env.secureCookie;
                this.apiUrl = env.apiUrl;
            }
        }

        // we're on an unknown host or something's gone wrong. default to local
        if(this.debug == undefined || this.apiUrl == undefined) {
            this.debug == this.envSettings.local.debug;
            this.secureCookie == this.envSettings.local.secureCookie;
            this.apiUrl == this.envSettings.local.apiUrl;
        }

        this.hostUrl = protocol + '//' + hostname;
        this.portalUrl = protocol + '//' + hostname + '/portal';
        this.resourcesUrl=protocol+'//'+hostname+'/wp-json/wp/v2/portal-resources/';
        this.resourceCategoriesUrl=protocol+'//'+hostname+'/wp-json/element/v1/portal-categories/';
    },

    // used to determine if an error response should redirect the user to the login
    loginUrl: '/portal/login/session',
    redirectResponseCodes: [
        'INVALID_TOKEN',
        'EXPIRED_TOKEN'
    ],

    // basic chart configurations
    chartOptions: {

        // line and area charts
        timeline: {
            backgroundColor: {
                fill: '#fcfbfc',
                stroke: '#e6e6e6',
                strokeWidth: 3
            },
            chartArea: {
                width: '100%',
                height: '100%'
            },
            legend: {
                position: 'in'
            },
            titlePosition: 'in',
            axisTitlesPosition: 'in',
            hAxis: {
                textPosition: 'in',
            },
            vAxis: {
                textPosition: 'in',
            }
        },

        // donut pie charts
        donut: {
            backgroundColor: {
                fill: '#fcfbfc',
            },
            chartArea: {
                width: '95%',
                height: '95%'
            },
            legend: {
                position: 'right',
                alignment: 'center',
                textStyle: { fontSize: 12 }
            },
            pieHole: .5
        },

    },

    // the bullet colors based on ticket statuses
    ticketStatusBulletColors: {
        'closed' : 'green',
        'canceled' : 'green',
        'postponed' : 'yellow',
        'deferred to client' : 'red',
    },

    // routes to the api
    routes: [
        {
            "route": "/accounts/add-account",
            "uri": "/accounts/add-account",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "invoice_number",
                "account_number"
            ]
        },
        {
            "route": "/accounts/get-accounts",
            "uri": "/accounts/get-accounts",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/accounts/remove-accounts",
            "uri": "/accounts/remove-accounts",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "accounts.*.account_id"
            ]
        },
        {
            "route": "/accounts/update-accounts",
            "uri": "/accounts/update-accounts",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "accounts.*.account_id"
            ]
        },
        {
            "route": "/admin/add-account",
            "uri": "/admin/add-account/{accountId}/{accessLevel}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/admin/clear-accounts",
            "uri": "/admin/clear-accounts",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/admin/find-accounts",
            "uri": "/admin/find-accounts/{perPage}",
            "auth": true,
            "method": "GET",
            "methodParameters": [
                "sort_column",
                "sort_order",
                "search_all",
                "search_user"
            ]
        },
        {
            "route": "/admin/get-token-as-user",
            "uri": "/admin/get-token-as-user/{userId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/admin/get-user-accounts",
            "uri": "/admin/get-user-accounts/{userId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/admin/get-user-by-email",
            "uri": "/admin/get-user-by-email/{email}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/admin/get-user",
            "uri": "/admin/get-user/{userId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/auth/confirm-user-password",
            "uri": "/auth/confirm-user-password",
            "auth": false,
            "method": "POST",
            "methodParameters": [
                "email",
                "password"
            ]
        },
        {
            "route": "/auth/forgot-password",
            "uri": "/auth/forgot-password/{email}",
            "auth": false,
            "method": "GET"
        },
        {
            "route": "/auth/get-token",
            "uri": "/auth/get-token",
            "auth": false,
            "method": "POST",
            "methodParameters": [
                "email",
                "password",
                "passcode"
            ]
        },
        {
            "route": "/auth/reset-password",
            "uri": "/auth/reset-password",
            "auth": false,
            "method": "POST",
            "methodParameters": [
                "reset_key",
                "email_nm",
                "passwd",
                "confirm"
            ]
        },
        {
            "route": "/contact/avatar",
            "uri": "/contact/avatar/{userId}",
            "auth": false,
            "method": "GET"
        },
        {
            "route": "/contact/get-team",
            "uri": "/contact/get-team/{accountId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/contact/inquire",
            "uri": "/contact/inquire",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "inquiry_type",
                "first_name",
                "last_name",
                "email",
                "subject",
                "inquiry",
                "value"
            ]
        },
        {
            "route": "/implementation/get-account-bundles",
            "uri": "/implementation/get-account-bundles[/{accountId}]",
            "auth": true,
            "method": "GET",
        },
        {
            "route": "/implementation/send-docusign-emails",
            "uri": "/implementation/send-docusign-emails/{customerBundleFormId}",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "templateId",
                "subject",
                "emails"
            ],
        },
        {
            "route": "/implementation/void-docusign-envelope",
            "uri": "/implementation/void-docusign-envelope/{customerBundleFormId}/{envelopeId}",
            "auth": true,
            "method": "POST"
        },
        {
            "route": "/implementation/resend-docusign-envelope",
            "uri": "/implementation/resend-docusign-envelope/{customerBundleFormId}/{envelopeId}",
            "auth": true,
            "method": "POST"
        },
        {
            "route": "/implementation/get-bundle-form-details",
            "uri": "/implementation/get-bundle-form-details/{customerBundleFormId}",
            "auth": true,
            "method": "GET",
        },
        {
            "route": "/implementation/get-form-details",
            "uri": "/implementation/get-form-details/{formId}",
            "auth": true,
            "method": "GET",
        },
        {
            "route": "/implementation/assign-users-to-form",
            "uri": "/implementation/assign-users-to-form/{customerBundleFormId}",
            "auth": true,
            "method": "POST",
            "methodParameters": [
              "users"
            ]
        },
        {
            "route": "/implementation/save-submission",
            "uri": "/implementation/save-submission/{customerBundleFormId}",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "data",
                "isSubmitted"
            ],
        },
        {
            "route": "/tickets/save-form-based-ticket",
            "uri": "/tickets/save-form-based-ticket/{formId}",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "account_id",
                "base_order_id",
                "order_unknown",
                "data",
                "subject",
                "description",
                "first_name",
                "last_name",
                "email",
                "phone",
                "contact_method",
                "compliance_pin"
            ]
        },
        {
            "route": "/tickets/get-form-results",
            "uri": "/tickets/get-form-results/{ticketId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/tickets/download-attachment",
            "uri": "/tickets/download-attachment/{ticketAttachmentId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/tickets/get-trouble-tree",
            "uri": "/tickets/get-trouble-tree/{baseOrderId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/implementation/upload-files",
            "uri": "/implementation/upload-files[/{customerBundleFormId}]",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "type",
                "files",
                "fieldName"
            ],
        },
        {
            "route": "/implementation/view-file",
            "uri": "/implementation/view-attachment/{customerBundleFormId}/file/{attachmentId}",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "files",
            ],
        },
        {
            "route": "/implementation/remove-uploaded-files",
            "uri": "/implementation/remove-uploaded-files/{customerBundleFormId}",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "files",
            ],
        },
        {
            "route": "/invoices/download-invoice-product-history",
            "uri": "/invoices/download-invoice-product-history/{accountId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/invoices/download-invoice",
            "uri": "/invoices/download-invoice/{accountId}/{cycleLogId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/invoices/get-balance-history",
            "uri": "/invoices/get-balance-history",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/invoices/get-invoice-products",
            "uri": "/invoices/get-invoice-products/{accountId}/{cycleLogId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/invoices/get-invoice",
            "uri": "/invoices/get-invoice/{accountId}/{cycleLogId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/invoices/get-invoices",
            "uri": "/invoices/get-invoices/{perPage}[/{accountId}]",
            "auth": true,
            "method": "GET",
            "methodParameters": [
                "sort_column",
                "sort_order",
                "search_all"
            ]
        },
        {
            "route": "/invoices/get-latest-invoice",
            "uri": "/invoices/get-latest-invoice/{accountId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/legal/accept-agreement",
            "uri": "/legal/accept-agreement/{legalAgreementId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/legal/get-active-agreements",
            "uri": "/legal/get-active-agreements",
            "auth": false,
            "method": "GET"
        },
        {
            "route": "/legal/get-agreement",
            "uri": "/legal/get-agreement/{legalAgreementId}",
            "auth": false,
            "method": "GET"
        },
        {
            "route": "/legal/get-unnaccepted-agreements",
            "uri": "/legal/get-unnaccepted-agreements",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/network/download-network-stats",
            "uri": "/network/download-network-stats/{baseOrderId}/{interfaceId}/{chartType}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/network/get-network-order",
            "uri": "/network/get-network-order/{baseOrderId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/network/get-network-stats",
            "uri": "/network/get-network-stats/{baseOrderId}/{interfaceId}/{chartType}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/notifications/get-active-cmc-notifications-count",
            "uri": "/notifications/get-active-cmc-notifications-count",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/notifications/get-cmc-notification",
            "uri": "/notifications/get-cmc-notification/{notificationId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/notifications/get-cmc-notifications",
            "uri": "/notifications/get-cmc-notifications/{perPage}[/{accountId}]",
            "auth": true,
            "method": "GET",
            "methodParameters": [
                "sort_column",
                "sort_order",
                "search_all"
            ]
        },
        {
            "route": "/notifications/get-outages",
            "uri": "/notifications/get-outages",
            "auth": false,
            "method": "GET"
        },
        {
            "route": "/orders-bs/get-bs-managed-backup",
            "uri": "/orders-bs/get-bs-managed-backup/{resourceId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-bs/get-bs-managed-backups",
            "uri": "/orders-bs/get-bs-managed-backups/{baseOrderId}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-bs/get-bs-resource-backups",
            "uri": "/orders-bs/get-bs-resource-backups/{perPage}/{resourceId}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-bs/get-bs-storage-stats",
            "uri": "/orders-bs/get-bs-storage-stats/{baseOrderId}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-bs/get-order-bs",
            "uri": "/orders-bs/get-order-bs/{baseOrderId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-ch/get-ch-stats",
            "uri": "/orders-ch/get-ch-stats/{baseOrderId}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-ch/get-order-ch",
            "uri": "/orders-ch/get-order-ch/{baseOrderId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-ch/get-protected-objects",
            "uri": "/orders-ch/get-protected-objects/{perPage}/{baseOrderId}",
            "auth": true,
            "method": "GET",
            "methodParameters": [
                "sort_column",
                "sort_order",
                "search_all"
            ]
        },
        {
            "route": "/orders-cv/get-cv-stats",
            "uri": "/orders-cv/get-cv-stats/{baseOrderId}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-cv/get-order-cv",
            "uri": "/orders-cv/get-order-cv/{baseOrderId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-dd/get-dd-stats",
            "uri": "/orders-dd/get-dd-stats/{baseOrderId}/{zoneId}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-dd/get-dd-zones",
            "uri": "/orders-dd/get-dd-zones/{baseOrderId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-dd/get-order-dd",
            "uri": "/orders-dd/get-order-dd/{baseOrderId}/{zoneId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-dd/get-threat-countries",
            "uri": "/orders-dd/get-threat-countries/{baseOrderId}/{zoneId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-ds/download-vms",
            "uri": "/orders-ds/download-vms/{baseOrderId}[/{vpgId}]",
            "auth": true,
            "method": "GET",
            "methodParameters": [
                "sort_column",
                "sort_order",
                "search_all"
            ]
        },
        {
            "route": "/orders-ds/get-ds-stats",
            "uri": "/orders-ds/get-ds-stats/{baseOrderId}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-ds/get-order-ds",
            "uri": "/orders-ds/get-order-ds/{baseOrderId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-ds/get-vm-stats",
            "uri": "/orders-ds/get-vm-stats/{vmId}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-ds/get-vm",
            "uri": "/orders-ds/get-vm/{vmId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-ds/get-vms",
            "uri": "/orders-ds/get-vms/{perPage}/{baseOrderId}[/{vpgId}]",
            "auth": true,
            "method": "GET",
            "methodParameters": [
                "sort_column",
                "sort_order",
                "search_all"
            ]
        },
        {
            "route": "/orders-ds/get-vpg-stats",
            "uri": "/orders-ds/get-vpg-stats/{vpgId}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-ds/get-vpg",
            "uri": "/orders-ds/get-vpg/{vpgId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-eb/get-eb-agent-client-stats",
            "uri": "/orders-eb/get-eb-agent-client-stats/{baseOrderId}/{clientName}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-eb/get-eb-agent-client",
            "uri": "/orders-eb/get-eb-agent-client/{baseOrderId}/{clientName}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-eb/get-eb-agent-clients",
            "uri": "/orders-eb/get-eb-agent-clients/{perPage}/{baseOrderId}",
            "auth": true,
            "method": "GET",
            "methodParameters": [
                "sort_column",
                "sort_order",
                "search_all"
            ]
        },
        {
            "route": "/orders-eb/get-eb-image-machine-stats",
            "uri": "/orders-eb/get-eb-image-machine-stats/{baseOrderId}/{vmName}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-eb/get-eb-image-machine",
            "uri": "/orders-eb/get-eb-image-machine/{baseOrderId}/{vmName}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-eb/get-eb-image-machines",
            "uri": "/orders-eb/get-eb-image-machines/{perPage}/{baseOrderId}",
            "auth": true,
            "method": "GET",
            "methodParameters": [
                "sort_column",
                "sort_order",
                "search_all"
            ]
        },
        {
            "route": "/orders-eb/get-eb-stats",
            "uri": "/orders-eb/get-eb-stats/{baseOrderId}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-eb/get-order-eb",
            "uri": "/orders-eb/get-order-eb/{baseOrderId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-ed/get-ed-stats",
            "uri": "/orders-ed/get-ed-stats/{baseOrderId}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-ed/get-order-ed",
            "uri": "/orders-ed/get-order-ed/{baseOrderId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-oc/get-oc-stats",
            "uri": "/orders-oc/get-oc-stats/{baseOrderId}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-oc/get-order-oc",
            "uri": "/orders-oc/get-order-oc/{baseOrderId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-ob/get-buckets",
            "uri": "/orders-ob/get-buckets/{perPage}/{baseOrderId}",
            "auth": true,
            "method": "GET",
            "methodParameters": [
                "sort_column",
                "sort_order",
                "search_bucket"
            ]
        },
        {
            "route": "/orders-ob/get-ob-stats",
            "uri": "/orders-ob/get-ob-stats/{baseOrderId}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders-ob/get-order-ob",
            "uri": "/orders-ob/get-order-ob/{baseOrderId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders/change-alias",
            "uri": "/orders/change-alias",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "base_order_id",
                "alias"
            ]
        },
        {
            "route": "/orders/download-orders",
            "uri": "/orders/download-orders[/{accountId}]",
            "auth": true,
            "method": "GET",
            "methodParameters": [
                "perPage",
                "sort_column",
                "sort_order",
                "search_all",
                "search_product_cd",
                "search_product_group",
                "search_status",
                "search_order_number",
                "search_uss_circuit_id",
                "search_customer_ref"
            ]
        },
        {
            "route": "/orders/get-order",
            "uri": "/orders/get-order/{baseOrderId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders/get-orders",
            "uri": "/orders/get-orders/{perPage}[/{accountId}]",
            "auth": true,
            "method": "GET",
            "methodParameters": [
                "sort_column",
                "sort_order",
                "search_all",
                "search_product_cd",
                "search_product_group",
                "search_status",
                "search_order_number",
                "search_uss_circuit_id",
                "search_customer_ref"
            ]
        },
        {
            "route": "/orders/get-pending-orders",
            "uri": "/orders/get-pending-orders/{count}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/orders/get-products",
            "uri": "/orders/get-products[/{accountId}]",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/pins/get-user-accounts-pins",
            "uri": "/pins/get-user-accounts-pins",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/pins/reset-pin",
            "uri": "/pins/reset-pin",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "reset_key",
                "account_id"
            ]
        },
        {
            "route": "/pins/send-pin-reset",
            "uri": "/pins/send-pin-reset/{accountId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/resource-pools/download-resource-pool-vms",
            "uri": "/resource-pools/download-resource-pool-vms/{baseOrderId}",
            "auth": true,
            "method": "GET",
            "methodParameters": [
                "sort_column",
                "sort_order",
                "search_all"
            ]
        },
        {
            "route": "/resource-pools/get-resource-pool-order",
            "uri": "/resource-pools/get-resource-pool-order/{baseOrderId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/resource-pools/get-resource-pool-stats",
            "uri": "/resource-pools/get-resource-pool-stats/{baseOrderId}/{startDate}/{endDate}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/resource-pools/get-resource-pool-vms",
            "uri": "/resource-pools/get-resource-pool-vms/{baseOrderId}/{perPage}",
            "auth": true,
            "method": "GET",
            "methodParameters": [
                "sort_column",
                "sort_order",
                "search_all"
            ]
        },
        {
            "route": "/tickets/create-ticket",
            "uri": "/tickets/create-ticket",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "account_id",
                "base_order_id",
                "order_unknown",
                "subject",
                "description",
                "first_name",
                "last_name",
                "email",
                "phone",
                "contact_method",
                "compliance_pin",
                "files"
            ]
        },
        {
            "route": "/tickets/create-ticket-update",
            "uri": "/tickets/create-ticket-update/{ticketId}",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "description",
                "files"
            ]
        },
        {
            "route": "/tickets/get-open-tickets",
            "uri": "/tickets/get-open-tickets/{baseOrderId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/tickets/get-ticket",
            "uri": "/tickets/get-ticket/{ticketId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/tickets/get-tickets",
            "uri": "/tickets/get-tickets/{perPage}[/{accountId}]",
            "auth": true,
            "method": "GET",
            "methodParameters": [
                "sort_column",
                "sort_order",
                "search_all"
            ]
        },
        {
            "route": "/tickets/get-tickets-requesting-response",
            "uri": "/tickets/get-tickets-requesting-response",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/usage-based/get-usage-order",
            "uri": "/usage-based/get-usage-order/{baseOrderId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/usage-based/get-usage-stats",
            "uri": "/usage-based/get-usage-stats/{baseOrderId}/{startDate}/{endDate}[/{customerOrderComponentId}]",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/users/activate-two-factor-authentication-secret",
            "uri": "/users/activate-two-factor-authentication-secret",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "passcode",
                "secretKey"
            ]
        },
        {
            "route": "/users/add-existing-user",
            "uri": "/users/add-existing-user",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "email_nm",
                "accounts.*.account_id",
                "accounts.*.access_level"
            ]
        },
        {
            "route": "/users/add-new-user",
            "uri": "/users/add-new-user",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "email_nm",
                "first_nm",
                "last_nm",
                "accounts.*.account_id",
                "accounts.*.access_level"
            ]
        },
        {
            "route": "/users/create-user-from-hash",
            "uri": "/users/create-user-from-hash",
            "auth": false,
            "method": "POST",
            "methodParameters": [
                "hash",
                "account_id",
                "email_nm",
                "passwd",
                "confirm",
                "first_nm",
                "last_nm",
                "legal_agree",
                "g_recaptcha_response"
            ]
        },
        {
            "route": "/users/create-user-from-account",
            "uri": "/users/create-user-from-account",
            "auth": false,
            "method": "POST",
            "methodParameters": [
                "account_number",
                "email_nm",
                "first_nm",
                "last_nm",
                "legal_agree",
                "g_recaptcha_response"
            ]
        },
        {
            "route": "/users/create-user-from-invoice",
            "uri": "/users/create-user-from-invoice",
            "auth": false,
            "method": "POST",
            "methodParameters": [
                "invoice_number",
                "account_number",
                "email_nm",
                "passwd",
                "confirm",
                "first_nm",
                "last_nm",
                "legal_agree",
                "g_recaptcha_response"
            ]
        },
        {
            "route": "/users/delete-user",
            "uri": "/users/delete-user/{userId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/users/disable-two-factor-authentication",
            "uri": "/users/disable-two-factor-authentication",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "currentPassword"
            ]
        },
        {
            "route": "/users/get-authenticated-user",
            "uri": "/users/get-authenticated-user",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/users/get-two-factor-authentication-secret",
            "uri": "/users/get-two-factor-authentication-secret",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/users/get-user",
            "uri": "/users/get-user/{userId}",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/users/get-users",
            "uri": "/users/get-users",
            "auth": true,
            "method": "GET"
        },
        {
            "route": "/users/resend-verification",
            "uri": "/users/resend-verification",
            "auth": false,
            "method": "POST",
            "methodParameters": [
                "email_nm"
            ]
        },
        {
            "route": "/users/update-password",
            "uri": "/users/update-password",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "current_password",
                "passwd",
                "confirm"
            ]
        },
        {
            "route": "/users/update-profile",
            "uri": "/users/update-profile",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "email_nm",
                "first_nm",
                "last_nm",
                "passwd"
            ]
        },
        {
            "route": "/users/update-user",
            "uri": "/users/update-user/{userId}",
            "auth": true,
            "method": "POST",
            "methodParameters": [
                "accounts.*.account_id",
                "accounts.*.access_level"
            ]
        },
        {
            "route": "/users/verify-email",
            "uri": "/users/verify-email",
            "auth": false,
            "method": "POST",
            "methodParameters": [
                "userId",
                "hash"
            ]
        },
        {
            "route": "/users/verify-email-and-set-password",
            "uri": "/users/verify-email-and-set-password",
            "auth": false,
            "method": "POST",
            "methodParameters": [
                "userId",
                "hash",
                "passwd",
                "confirm",
                "g_recaptcha_response"
            ]
        }
    ]

}
PortalConfig._setEnv();
